// extracted by mini-css-extract-plugin
module.exports = {"main":"Layout_main__27Le0","purple-bg":"Layout_purple-bg__1PV3q"};